import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_TASK_RULES_REQUEST,
  GET_TASK_RULES_SUCCESS,
  GET_TASK_RULES_FAILURE,
  GET_TASK_RULE_REQUEST,
  GET_TASK_RULE_SUCCESS,
  GET_TASK_RULE_FAILURE,
  CREATE_TASK_RULE_REQUEST,
  CREATE_TASK_RULE_SUCCESS,
  CREATE_TASK_RULE_FAILURE,
  UPDATE_TASK_RULE_REQUEST,
  UPDATE_TASK_RULE_SUCCESS,
  UPDATE_TASK_RULE_FAILURE,
  DELETE_TASK_RULE_REQUEST,
  DELETE_TASK_RULE_SUCCESS,
  DELETE_TASK_RULE_FAILURE,
  GET_RULE_CONDITIONS_REQUEST,
  GET_RULE_CONDITIONS_SUCCESS,
  GET_RULE_CONDITIONS_FAILURE,
  ADD_RULE_CONDITION_REQUEST,
  ADD_RULE_CONDITION_SUCCESS,
  ADD_RULE_CONDITION_FAILURE,
  DELETE_RULE_CONDITION_REQUEST,
  DELETE_RULE_CONDITION_SUCCESS,
  DELETE_RULE_CONDITION_FAILURE,
  GET_RULE_CLIENTS_REQUEST,
  GET_RULE_CLIENTS_SUCCESS,
  GET_RULE_CLIENTS_FAILURE,
  ADD_RULE_CLIENT_REQUEST,
  ADD_RULE_CLIENT_SUCCESS,
  ADD_RULE_CLIENT_FAILURE,
  DELETE_RULE_CLIENT_REQUEST,
  DELETE_RULE_CLIENT_SUCCESS,
  DELETE_RULE_CLIENT_FAILURE,
  GET_VALID_TRIGGER_FIELDS_REQUEST,
  GET_VALID_TRIGGER_FIELDS_SUCCESS,
  GET_VALID_TRIGGER_FIELDS_FAILURE,
  GET_TASK_TRIGGER_SERVICES_REQUEST,
  GET_TASK_TRIGGER_SERVICES_SUCCESS,
  GET_TASK_TRIGGER_SERVICES_FAILURE,
  PROBE_SEGMENT_TABLES_REQUEST,
  PROBE_SEGMENT_TABLES_SUCCESS,
  PROBE_SEGMENT_TABLES_FAILURE,
  GENERATE_TASKS_FOR_RULE_REQUEST,
  GENERATE_TASKS_FOR_RULE_SUCCESS,
  GENERATE_TASKS_FOR_RULE_FAILURE,
  GENERATE_TASKS_ALL_RULES_REQUEST,
  GENERATE_TASKS_ALL_RULES_SUCCESS,
  GENERATE_TASKS_ALL_RULES_FAILURE,
  GET_RELO_POLICIES_BY_CLIENT_REQUEST,
  GET_RELO_POLICIES_BY_CLIENT_SUCCESS,
  GET_RELO_POLICIES_BY_CLIENT_FAILURE,
  CLEAR_CURRENT_RULE,
  CLEAR_VALID_TRIGGER_FIELDS,
  SET_RULE_FORM_FIELD,
  RESET_RULE_FORM,
} from './taskRules.types';

// ===== Task Rule CRUD =====

export const getTaskRules = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_TASK_RULES_REQUEST, GET_TASK_RULES_SUCCESS, GET_TASK_RULES_FAILURE],
    authenticated: true,
    endpoint: 'api/taskRules',
    method: 'GET',
  },
});

export const getTaskRule = (taskRuleId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_TASK_RULE_REQUEST, GET_TASK_RULE_SUCCESS, GET_TASK_RULE_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/getById/${taskRuleId}`,
    method: 'GET',
  },
});

export const createTaskRule = (ruleData) => ({
  [CALL_INTAKE_V2_API]: {
    types: [CREATE_TASK_RULE_REQUEST, CREATE_TASK_RULE_SUCCESS, CREATE_TASK_RULE_FAILURE],
    authenticated: true,
    endpoint: 'api/taskRules',
    method: 'POST',
    payload: ruleData,
  },
});

export const updateTaskRule = (taskRuleId, ruleData) => ({
  [CALL_INTAKE_V2_API]: {
    types: [UPDATE_TASK_RULE_REQUEST, UPDATE_TASK_RULE_SUCCESS, UPDATE_TASK_RULE_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/${taskRuleId}`,
    method: 'PUT',
    payload: ruleData,
  },
});

export const deleteTaskRule = (taskRuleId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_TASK_RULE_REQUEST, DELETE_TASK_RULE_SUCCESS, DELETE_TASK_RULE_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/${taskRuleId}`,
    method: 'DELETE',
  },
});

// ===== Trigger Conditions =====

export const getRuleConditions = (taskRuleId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_RULE_CONDITIONS_REQUEST, GET_RULE_CONDITIONS_SUCCESS, GET_RULE_CONDITIONS_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/${taskRuleId}/conditions`,
    method: 'GET',
  },
});

// taskRuleId goes in the payload body (not the path)
export const addRuleCondition = (taskRuleId, conditionData) => ({
  [CALL_INTAKE_V2_API]: {
    types: [ADD_RULE_CONDITION_REQUEST, ADD_RULE_CONDITION_SUCCESS, ADD_RULE_CONDITION_FAILURE],
    authenticated: true,
    endpoint: 'api/taskRules/conditions',
    method: 'POST',
    payload: { ...conditionData, taskRuleId },
  },
});

export const deleteRuleCondition = (conditionId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_RULE_CONDITION_REQUEST, DELETE_RULE_CONDITION_SUCCESS, DELETE_RULE_CONDITION_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/conditions/${conditionId}`,
    method: 'DELETE',
  },
});

// ===== Client Inclusions =====

// Backend expects GET api/taskRules/clients/{taskRuleId}
export const getRuleClients = (taskRuleId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_RULE_CLIENTS_REQUEST, GET_RULE_CLIENTS_SUCCESS, GET_RULE_CLIENTS_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/clients/${taskRuleId}`,
    method: 'GET',
  },
});

// taskRuleId goes in the payload body (not the path)
export const addRuleClient = (taskRuleId, clientData) => ({
  [CALL_INTAKE_V2_API]: {
    types: [ADD_RULE_CLIENT_REQUEST, ADD_RULE_CLIENT_SUCCESS, ADD_RULE_CLIENT_FAILURE],
    authenticated: true,
    endpoint: 'api/taskRules/clients',
    method: 'POST',
    payload: { ...clientData, taskRuleId },
  },
});

export const deleteRuleClient = (inclusionId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [DELETE_RULE_CLIENT_REQUEST, DELETE_RULE_CLIENT_SUCCESS, DELETE_RULE_CLIENT_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/clients/${inclusionId}`,
    method: 'DELETE',
  },
});

// ===== Valid Trigger Fields =====

export const getValidTriggerFields = (triggerServiceId, isSegmentLevel) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_VALID_TRIGGER_FIELDS_REQUEST, GET_VALID_TRIGGER_FIELDS_SUCCESS, GET_VALID_TRIGGER_FIELDS_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/${triggerServiceId}/triggerFields?isSegmentLevel=${isSegmentLevel}`,
    method: 'GET',
  },
});

// ===== Trigger Services =====

// Returns every Task.TaskTriggerServiceGroup row (inactive included); callers filter isActive for pickers
export const getTaskTriggerServices = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_TASK_TRIGGER_SERVICES_REQUEST, GET_TASK_TRIGGER_SERVICES_SUCCESS, GET_TASK_TRIGGER_SERVICES_FAILURE],
    authenticated: true,
    endpoint: 'api/taskRules/triggerServices',
    method: 'GET',
  },
});

// Asks the existing trigger-fields endpoint what a service offers at segment level; the reducer records whether
// any non-File (segment) table came back. context carries the service id into the success action.
export const probeSegmentTables = (triggerServiceId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [PROBE_SEGMENT_TABLES_REQUEST, PROBE_SEGMENT_TABLES_SUCCESS, PROBE_SEGMENT_TABLES_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/${triggerServiceId}/triggerFields?isSegmentLevel=true`,
    method: 'GET',
    context: { triggerServiceId },
  },
});

// ===== Generate Tasks =====

// generatedBy goes as a path param (not body)
export const generateTasksForRule = (taskRuleId, generatedBy) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GENERATE_TASKS_FOR_RULE_REQUEST, GENERATE_TASKS_FOR_RULE_SUCCESS, GENERATE_TASKS_FOR_RULE_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/${taskRuleId}/generate/${generatedBy}`,
    method: 'POST',
  },
});

// generatedBy goes as a path param (not body); segment renamed to generateAll
export const generateTasksAllRules = (generatedBy) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GENERATE_TASKS_ALL_RULES_REQUEST, GENERATE_TASKS_ALL_RULES_SUCCESS, GENERATE_TASKS_ALL_RULES_FAILURE],
    authenticated: true,
    endpoint: `api/taskRules/generateAll/${generatedBy}`,
    method: 'POST',
  },
});

// ===== Relocation Policies =====

export const getReloPoliciesByClient = (clientRecordId) => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_RELO_POLICIES_BY_CLIENT_REQUEST, GET_RELO_POLICIES_BY_CLIENT_SUCCESS, GET_RELO_POLICIES_BY_CLIENT_FAILURE],
    authenticated: true,
    endpoint: `api/Client/${clientRecordId}/relocation-policies`,
    method: 'GET',
  },
});

// ===== Local State Actions =====

export const clearCurrentRule = () => ({
  type: CLEAR_CURRENT_RULE,
});

export const clearValidTriggerFields = () => ({
  type: CLEAR_VALID_TRIGGER_FIELDS,
});

export const setRuleFormField = (field, value) => ({
  type: SET_RULE_FORM_FIELD,
  payload: { field, value },
});

export const resetRuleForm = () => ({
  type: RESET_RULE_FORM,
});
